import { useState, } from "react";
import MoonLoader from "react-spinners/MoonLoader";

const override = {
  display: "block",
  margin: "15rem auto",
  borderColor: "red",
};

function Loader() {
  let [loading, setLoading] = useState(true);
  let [color, setColor] = useState("#e53b3b");

  return (
    <div className="sweet-loading">
      <MoonLoader color={color} loading={loading} cssOverride={override} size={30} />
    </div>
  );
}

export default Loader;